import React from "react";

import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import ListSubheader from "@material-ui/core/ListSubheader";
import Divider from "@material-ui/core/Divider";
import Button from "@material-ui/core/Button";
import { Checkbox, ListItemText } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { i18n } from "../../translate/i18n";

const useStyles = makeStyles(theme => ({
	root: {
		width: "100%",
		marginTop: -4,
	},
	formControl: {
		width: "100%",
	},
	select: {
		borderRadius: 4,
		backgroundColor: theme.palette.background.paper,
		"& .MuiSelect-select": {
			display: "flex",
			alignItems: "center",
			minHeight: 20,
			paddingTop: 10,
			paddingBottom: 10,
			paddingLeft: 12,
			paddingRight: 30,
			fontSize: 14,
			whiteSpace: "nowrap",
			overflow: "hidden",
			textOverflow: "ellipsis",
		},
		"& .MuiOutlinedInput-notchedOutline": {
			borderColor: theme.palette.type === "dark" ? "#41506a" : "#cfd8e4",
		},
		"&:hover .MuiOutlinedInput-notchedOutline": {
			borderColor: theme.palette.primary.main,
		},
	},
	menuPaper: {
		marginTop: 6,
		minWidth: 220,
		border: `1px solid ${theme.palette.type === "dark" ? "#334158" : "#dce4ee"}`,
		borderRadius: 6,
		boxShadow: "0 10px 28px rgba(18, 31, 56, 0.16)",
	},
	menuList: {
		paddingTop: 4,
		paddingBottom: 4,
	},
	menuActions: {
		display: "flex",
		alignItems: "center",
		justifyContent: "space-between",
		padding: "4px 8px",
	},
	menuAction: {
		minWidth: 0,
		padding: "5px 8px",
		fontSize: 12,
		fontWeight: 700,
		textTransform: "none",
	},
	menuItem: {
		minHeight: 40,
		padding: "4px 10px",
		"&.Mui-selected": {
			backgroundColor: theme.palette.type === "dark" ? "rgba(91, 115, 255, 0.2)" : "#eef3ff",
		},
		"&.Mui-selected:hover, &:hover": {
			backgroundColor: theme.palette.type === "dark" ? "rgba(91, 115, 255, 0.28)" : "#e6edff",
		},
	},
	checkbox: {
		padding: 6,
	},
}));

const TicketsQueueSelect = ({
	userQueues,
	selectedQueueIds = [],
	onChange,
}) => {
	const classes = useStyles();
	const queueIds = userQueues?.map(queue => queue.id) || [];

	const handleChange = e => {
		onChange(e.target.value);
	};

	const handleSelectAll = event => {
		event.preventDefault();
		event.stopPropagation();
		onChange(queueIds);
	};

	const handleClear = event => {
		event.preventDefault();
		event.stopPropagation();
		onChange([]);
	};

	return (
		<div className={classes.root}>
			<FormControl className={classes.formControl} margin="dense">
				<Select
					multiple
					displayEmpty
					variant="outlined"
					className={classes.select}
					value={selectedQueueIds}
					onChange={handleChange}
					inputProps={{ "aria-label": "Filtrar por colas" }}
					MenuProps={{
						classes: {
							paper: classes.menuPaper,
							list: classes.menuList,
						},
						anchorOrigin: {
							vertical: "bottom",
							horizontal: "left",
						},
						transformOrigin: {
							vertical: "top",
							horizontal: "left",
						},
						getContentAnchorEl: null,
					}}
					renderValue={() => i18n.t("ticketsQueueSelect.placeholder")}
				>
					<ListSubheader component="div" disableSticky className={classes.menuActions}>
						<Button className={classes.menuAction} color="primary" onClick={handleSelectAll}>
							Todas
						</Button>
						<Button
							className={classes.menuAction}
							color="primary"
							disabled={selectedQueueIds.length === 0}
							onClick={handleClear}
						>
							Limpiar
						</Button>
					</ListSubheader>
					<Divider />
					{userQueues?.length > 0 &&
						userQueues.map(queue => (
							<MenuItem className={classes.menuItem} dense key={queue.id} value={queue.id}>
								<Checkbox
									className={classes.checkbox}
									style={{
										color: queue.color,
									}}
									size="small"
									color="primary"
									checked={selectedQueueIds.indexOf(queue.id) > -1}
								/>
								<ListItemText primary={queue.name} />
							</MenuItem>
						))}
				</Select>
			</FormControl>
		</div>
	);
};

export default TicketsQueueSelect;
